import { render, staticRenderFns } from "./seckillAdd.vue?vue&type=template&id=438108ba&scoped=true"
import script from "./seckillAdd.vue?vue&type=script&lang=js"
export * from "./seckillAdd.vue?vue&type=script&lang=js"
import style0 from "./seckillAdd.vue?vue&type=style&index=0&id=438108ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438108ba",
  null
  
)

export default component.exports